import { render } from "./technical.vue?vue&type=template&id=b900a014&scoped=true"
import script from "./technical.vue?vue&type=script&lang=js"
export * from "./technical.vue?vue&type=script&lang=js"

import "./technical.vue?vue&type=style&index=0&id=b900a014&lang=css"
import "./technical.vue?vue&type=style&index=1&id=b900a014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b900a014"]])

export default __exports__